// v5.0.1: custom element is now "variant-picker" (was "variant-selects"/"variant-radios")
const variantPicker = document.querySelector('variant-picker');
if (variantPicker) {
  const hasFieldsets = variantPicker.querySelectorAll('fieldset').length > 0;
  const pickerType = hasFieldsets ? 'radios' : 'selects';
  const fieldsets = hasFieldsets
    ? Array.from(variantPicker.querySelectorAll('fieldset'))
    : Array.from(variantPicker.querySelectorAll('.product-form__input--dropdown'));

  // v5.0.1: variants JSON is in [data-product-variants] (added separately)
  const variantsEl = variantPicker.querySelector('[data-variants]');
  if (variantsEl) {
    const productJson = JSON.parse(variantsEl.textContent);
    let selectedOptions = [];
    variantPicker.addEventListener('change', rebuildOptions);
    rebuildOptions();

    // Check if a given option value forms a valid combination with the already-selected options.
    function validCombo(inputValue, optionLevel) {
      for (let i = 0; i < productJson.length; i++) {
        if (optionLevel == 1) {
          if (productJson[i].option1 === selectedOptions[0] && productJson[i].option2 === inputValue) { return true; }
        } else {
          if (productJson[i].option1 === selectedOptions[0] && productJson[i].option2 === selectedOptions[1] && productJson[i].option3 === inputValue) { return true; }
        }
      }
    }

    function rebuildOptions() {
      selectedOptions = fieldsets.map((fieldset) => {
        if (pickerType === 'radios') {
          const checked = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
          return checked ? checked.value : '';
        }
        return fieldset.querySelector('select') ? fieldset.querySelector('select').value : '';
      });

      // Update contact/callback form field.
      if (document.getElementById('ContactFormProductVariant')) {
        document.getElementById('ContactFormProductVariant').value = selectedOptions.join(' / ');
      }

      // Loop through option sets starting from the 2nd set and disable invalid options.
      for (let optionLevel = 1, n = fieldsets.length; optionLevel < n; optionLevel++) {
        const inputs = (pickerType === 'radios')
          ? fieldsets[optionLevel].querySelectorAll('input')
          : fieldsets[optionLevel].querySelectorAll('option');

        inputs.forEach(input => {
          input.disabled = !validCombo(input.value, optionLevel);
          if (pickerType === 'radios') {
            const li = document.getElementById('item-' + input.id);
            if (li) li.style.display = input.disabled ? 'none' : '';

            const label = fieldsets[optionLevel].querySelector(`label[for="${input.id}"]`);
            if (label) label.style.display = input.disabled ? 'none' : '';
          } else {
            input.hidden = !validCombo(input.value, optionLevel);
          }
        });
      }

      // If the selected option is now disabled, select the first available one instead.
      for (let optionLevel = 1, fieldsetsLength = fieldsets.length, change = false; optionLevel < fieldsetsLength && !change; optionLevel++) {
        if (pickerType === 'radios') {
          const checked = fieldsets[optionLevel].querySelector('input:checked');
          if (checked && checked.disabled) {
            const first = fieldsets[optionLevel].querySelector('input:not(:disabled)');
            if (first) { first.checked = true; change = true; }
          }
        } else {
          const selected = fieldsets[optionLevel].querySelector('option:checked');
          if (selected && selected.disabled) {
            const first = fieldsets[optionLevel].querySelector('option:not(:disabled)');
            if (first) { first.selected = true; change = true; }
          }
        }
        if (change) variantPicker.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }
}
